import React from 'react';

import { branchSettingsPropType, patientPropType } from 'Shared/types';
import PropTypes from 'prop-types';
import EhrEncounterReviewContent from 'App/components/EHR/EhrEncounterReviewContent';
import OverturnedReviewContent from 'App/features/ReferralManager/Referral/AppealPage/EncounterModal/OverturnedReviewContent';
import DefaultReviewContent from 'App/features/ReferralManager/Referral/AppealPage/EncounterModal/DefaultReviewContent';
import { appealReferralDetailsPropType } from './types';

const AppealEncounterReviewContent = ({
    patient,
    branchSettings,
    medicationList,
    appealReferralDetails,
    status,
    appealDocs,
}) => {
    const isStatusOverturned = status.toUpperCase() === 'OVERTURNED';

    return (
        <div>
            <EhrEncounterReviewContent
                patient={patient}
                branchSettings={branchSettings}
                medicationList={medicationList}
            />
            {isStatusOverturned && (
                <OverturnedReviewContent
                    appealReferralDetails={appealReferralDetails}
                    status={status}
                    appealDocs={appealDocs}
                />
            )}
            {!isStatusOverturned && (
                <DefaultReviewContent
                    appealReferralDetails={appealReferralDetails}
                    status={status}
                    appealDocs={appealDocs}
                />
            )}
        </div>
    );
};

AppealEncounterReviewContent.propTypes = {
    status: PropTypes.string.isRequired,
    patient: patientPropType.isRequired,
    branchSettings: branchSettingsPropType.isRequired,
    medicationList: PropTypes.arrayOf(
        PropTypes.shape({
            medication: PropTypes.shape({
                id: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            }),
        })
    ).isRequired,
    appealReferralDetails: appealReferralDetailsPropType.isRequired,
    appealDocs: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default AppealEncounterReviewContent;
